import { NgModule } from '@angular/core';
import { ProviderRoutingModule } from './provider-routing.module';


@NgModule({
  declarations: [
  ],
  imports: [
    ProviderRoutingModule,
  ]
})
export class ProviderModule { }
